export default __webpack_public_path__ + "static/media/aglc-logo.ca94152d.svg";